<template>
  <div>
    <v-stepper v-model="currentStep">
      <v-stepper-header>
        <v-stepper-step
          class="cursor"
          :complete="currentStep > 1"
          step="1"
          @click="setStep(1)"
        >{{$t('mainData')}}</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
          class="cursor"
          :complete="currentStep > 2"
          step="2"
          @click="setStep(2)"
        >{{$t('categoryAssign')}}</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
          class="cursor"
          :complete="currentStep > 3"
          step="3"
          @click="setStep(3)"
        >{{$t('aspectAssign')}}</v-stepper-step>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content step="1">
          <v-flex d-flex lg12 md12 sm12 xs12>
            <v-flex d-flex lg3 md3 sm12 xs12>
              <v-switch
                v-model="actLocal.active"
                :disabled="!Edit"
                :label="$t('active')"
                color="primary"
              ></v-switch>
            </v-flex>
            <v-flex d-flex lg3 md3 sm12 xs12>
              <v-switch
                v-model="actLocal.faultSystem"
                :disabled="!Edit"
                :label="$t('ifFaultSystem')"
                color="primary"
              ></v-switch>
            </v-flex>
            <v-flex d-flex lg3 md3 sm12 xs12 v-if="actLocal.faultSystem">
              <div style="max-width: 140px;">
                <v-text-field
                  type="number"
                  :min="1"
                  :label="$t('seriousFaultsValue')"
                  v-model="actLocal.seriousFaultNumber"
                ></v-text-field>
              </div>
            </v-flex>
            <v-flex d-flex lg3 md3 sm12 xs12 v-if="actLocal.faultSystem">
              <div style="max-width: 140px;">
                <v-text-field
                  type="number"
                  :min="1"
                  :label="$t('smallFaultValue')"
                  v-model="actLocal.smallFaultNumber"
                ></v-text-field>
              </div>
            </v-flex>
          </v-flex>
          <v-flex d-flex lg12 md12 sm12 xs12>
            <v-tabs color="primary" fixed-tabs ref="tablanguage">
              <v-tab
                :key="index + 100"
                v-for="(lang, index) in actLocal.name"
              >{{lang.language.name}}</v-tab>
              <v-tab-item :key="index + 200" v-for="(lang, index) in actLocal.name">
                <v-container fluid grid-list-xl>
                  <v-layout wrap>
                    <v-flex d-flex lg12 md12 sm12 xs12>
                      <IgTextField
                        :disabled="!Edit"
                        :rules="[v => !lang.language.required || rules.vacio(v, 'name')]"
                        :status="true"
                        :label="$t('name')"
                        v-model="lang.text"
                      ></IgTextField>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-tab-item>
            </v-tabs>
          </v-flex>
        </v-stepper-content>
        <v-stepper-content step="2">
          <tab-category @updateCategory="updateCategory" @updateType="updateTypes"></tab-category>
        </v-stepper-content>
        <v-stepper-content step="3">
          <tab-aspects :action="action" @update="updateAspects"></tab-aspects>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <v-flex xs12>
      <v-card>
        <v-card-text>
          <v-container grid-list-md text-xs-left>
            <v-card color="transparent" flat light>
              <v-card-text class="px-0" v-if="!editExternal">
                <v-layout :key="item._id" row v-for="item in infoAct" wrap>
                  <v-flex xs6>{{item.field}}</v-flex>
                  <v-flex xs6>{{item.data}}</v-flex>
                </v-layout>
                <v-layout>
                  <v-flex d-flex lg12 md12 sm12 xs12>
                    <v-spacer></v-spacer>
                    <v-flex d-flex sm4>
                      <v-btn
                        @click="removeForm()"
                        color="error"
                        :loading="loading"
                        v-if="action === 'remove'"
                      >{{$t('delete')}}</v-btn>
                    </v-flex>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-text class="px-0" v-else>
                <v-layout wrap>
                  <v-flex d-flex lg12 md12 sm12 xs12></v-flex>
                </v-layout>
                <v-layout>
                  <v-flex d-flex lg12 md12 sm12 xs12>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        small
                        v-if="action==='update' && currentStep > 1"
                        @click="currentStep-=1"
                      >&lt;&lt; {{$t('previous')}}</v-btn>
                      <v-btn @click="clearForm()" color="warning" small>{{$t('reset')}}</v-btn>

                      <v-btn
                        @click="validarForm()"
                        color="success"
                        :loading="loading"
                        small
                        v-if="currentStep===1 && action==='create'"
                      >{{$t('create')}}</v-btn>
                      <template v-if="can('edit', 'act', act)">
                        <v-btn
                          @click="firstUpdateForm()"
                          :loading="loading"
                          color="secondary"
                          small
                          v-if="currentStep === 1 && action==='update'"
                        >{{$t('update')}}</v-btn>
                        <v-btn
                          @click="updateForm()"
                          :loading="loading"
                          :color="action === 'create' ? 'success' : 'secondary'"
                          small
                          v-if="currentStep === 2 && updateButton "
                        >{{action === 'create' ? 'Guardar' : 'Actualizar'}}</v-btn>
                        <v-btn
                          @click="finishForm()"
                          :loading="loading"
                          color="success"
                          small
                          v-if="currentStep === 3 && updateButton"
                        >{{$t('save')}}</v-btn>
                      </template>
                      <v-btn
                        color="primary"
                        small
                        v-if="action==='update' && currentStep < 3"
                        @click="currentStep+=1"
                      >{{$t('next')}} &gt;&gt;</v-btn>
                    </v-card-actions>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-container>
        </v-card-text>
      </v-card>
    </v-flex>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import queueToast from '../../../helpers/queueToast'
import rules from '../../../helpers/rules'
import tabAspects from './tabAspects'
import tabCategory from './tabCategory'

export default {
  name: 'tabInformacion',
  components: {
    tabAspects, tabCategory
  },
  mixins: [rules],
  props: {
    editExternal: {
      type: Boolean,
      required: false,
      default: true
    },
    action: {
      type: String,
      required: false,
      default: 'view'
    },
    status: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      actLocal: {},
      complexLanguage: [],
      currentStep: 1,
      template: {
        name: '',
        order: '0',
        faultSystem: false,
        seriousFaultNumber: 10,
        smallFaultNumber: 3
      },
      types: [],
      categories: [],
      localAspects: [],
      loading: false
    }
  },
  mounted () {
    this.updateActions()
  },
  watch: {
    action: function (val) {
      if (val == 'create') { this.updateActions() }
    },
    act: {
      handler (val) {
        if (val) {
          this.updateActions()
        }
      },
      deep: true
    },
    status: function () {
      this.updateActions()
    }
  },
  computed: {
    ...mapState({
      act: state => state.acts.actSelected,
      listUser: state => state.users.listaUsers,
      listLanguages: state => state.languages.listSelectLanguage,
      languages: state => state.languages.listLanguages,
      currentAct: state => state.acts.actSelected,
      authUser: state => state.authentication.user
    }),
    infoAct () {
      if (!this.act) { return [] }

      const baseData = this.act
      return [
        {
          field: this.$t('active'),
          data: baseData.active ? this.$t('yes') : this.$t('no')
        },
        {
          field: this.$t('createdBy'),
          data: baseData.createdBy ? this.userFormat(baseData.createdBy) : ''
        },
        {
          field: this.$t('createdAt'),
          data: baseData.createdAt ? this.dateFormat(baseData.createdAt) : ''
        }
      ]
    },
    title () {
      if (!this.act || !this.act.name) return ''
      if (this.action === 'create') {
        return this.$t('newAModel', { field: this.tc('act') })
      }
      if (this.act && this.act.name) { return this.getName(this.act.name) } else return this.$t('updateModel', { field: this.tc('act') })
    },
    Edit () {
      return this.editExternal
    },
    dialog: {
      get () {
        return this.status
      },
      set (value) {
        if (!value) {
          this.$emit('close')
          this.currentStep = 1
        }
      }
    },
    updateButton () {
      if (!this.categories || !this.types) {
        return false
      }
      return (this.categories.length > 0 && this.types.length > 0)
    }
  },
  methods: {
    ...mapActions({
      setNew: 'acts/setCreateNew',
      setUpdate: 'acts/setUpdate',
      setRemove: 'acts/setDelete'
    }),
    setStep (step) {
      if (this.act && this.act._id) {
        this.currentStep = step
      }
    },
    updateActions () {
      if (!this.act) {
        return
      }
      if (this.action === 'update') {
        let me = this
        setTimeout(function () {
          const baseData = me.act
          me.actLocal = {
            faultSystem: baseData.faultSystem,
            active: baseData.active,
            name: baseData.name,
            seriousFaultNumber: baseData.seriousFaultNumber,
            smallFaultNumber: baseData.smallFaultNumber,
            name: me.setComplexLanguage(baseData.name)
          }
          // me.createComplexLanguage()
        }, 50)
      }
      if (this.action === 'create') {
        this.actLocal = {
          active: true,
          faultSystem: false,
          name: this.setComplexLanguage(),
          seriousFaultNumber: 10,
          smallFaultNumber: 3,
          categoryAspect: {
            name: '',
            order: 0
          },
          typeAspect: {
            name: '',
            order: 0
          },
          aspect: {
            order: 0,
            aspectId: '',
            categoryAspect: '',
            typeAspect: ''
          },
          score: {
            fault: {
              type: '',
              objectId: '',
              seriousFaults: 0,
              smallFaults: 0,
              warning: 0
            },
            aspectScore: {
              aspectRelId: '',
              type: '',
              objectId: '',
              score: 0
            }
          }
        }
      }
      // this.createComplexLanguage()
    },
    dateFormat (date) {
      const newDate = new Date(date)
      return newDate.getDate() + ' / ' + (newDate.getMonth() + 1) + ' / ' + newDate.getFullYear()
    },
    userFormat (userId) {
      let result = this.listUser.find(item => item._id === userId)
      return result ? result.name : ''
    },
    languageFormat (languageId) {
      let result = this.listLanguages.find(item => item.value === languageId)
      return result ? result.text : ''
    },
    clearForm () {
      this.actLocal = {
        active: false,
        name: '',
        faultSystem: ''
      }
      this.complexLanguage = []
    },
    errorForm () {
      let error = false
      let message = []

      let defaultLangId = this.$store.state.languages.defaultLangId
      const spanishLang = this.actLocal.name.find(lang => lang.langId === defaultLangId)
      if (!spanishLang || !spanishLang.text) {
        error = true
        message.push(this.$t('error.nameSpanish'))
      }

      return {
        error,
        message
      }
    },
    createAct () {
      const active = this.actLocal.active
      let name = this.getComplexLanguage(this.actLocal.name)
      // this.complexLanguage.forEach(item => {
      //   if (item.actName) {
      //     name.push({
      //       langId: item._id,
      //       text: item.actName
      //     })
      //   }
      // })
      return {
        name,
        active,
        faultSystem: this.actLocal.faultSystem ? this.actLocal.faultSystem : false,
        seriousFaultNumber: this.actLocal.seriousFaultNumber,
        smallFaultNumber: this.actLocal.smallFaultNumber
      }
    },
    firstUpdateForm () {
      const error = this.errorForm()
      if (error.error) {
        queueToast(error.message)
        return
      }
      let send = Object.assign({}, this.act)
      let me = this

      send.name = this.getComplexLanguage(this.actLocal.name)

      send.active = this.actLocal.active
      send.faultSystem = this.actLocal.faultSystem
      send.seriousFaultNumber = this.actLocal.seriousFaultNumber
      send.smallFaultNumber = this.actLocal.smallFaultNumber
      this.loading = true
      this.setUpdate(send)
        .then(_ => this.currentStep = 2)
        .finally(_ => this.loading = false)
    },
    validarForm () {
      const error = this.errorForm()
      if (error.error) {
        queueToast(error.message)
        return
      }
      this.loading = true
      this.setNew(this.createAct())
        .then(_ => this.currentStep = 2)
        .finally(_ => this.loading = false)
    },
    finishForm () {
      let act = Object.assign({}, this.act)
      act.aspects = this.localAspects

      this.loading = true
      this.setUpdate(act)
        .then(_ => this.dialog = false)
        .finally(_ => this.loading = false)
    },
    updateForm () {
      let act = Object.assign({}, this.currentAct)
      act.categoryAspects = this.categories
      act.typeAspects = this.types
      this.loading = true
      this.setUpdate(act)
        .then(_ => this.currentStep = 3)
        .finally(_ => this.loading = false)
    },
    removeForm () {
      this.loading = true
      this.setRemove(this.act._id)
        .then(_ => this.$emit('close'))
        .finally(_ => this.loading = false)
    },
    formatLanguage (text, idLanguage) {
      if (!Array.isArray(text)) return text
      let item = text.find(item => item.langId === idLanguage)
      if (item) return item.text
      return '*'
    },
    // createComplexLanguage() {
    //   let me = this
    //   this.complexLanguage = []
    //   this.languages.forEach(item => {
    //     item.actName = undefined
    //     me.complexLanguage.push(item)
    //   })
    //   if (this.action === 'update' || this.action === 'delete') {
    //     this.complexLanguage.forEach((item, index) => {
    //       if (me.act && me.act.name) {
    //         let name = me.act.name.find(element => element.langId === item._id)
    //         if (name) {
    //           me.complexLanguage[index].actName = name.text
    //         }
    //       }
    //     })
    //   }
    // },
    updateCategory (value) {
      this.categories = value
    },
    updateTypes (value) {
      this.types = value
    },
    updateAspects (value) {
      this.localAspects = value
    }
  }

}
</script>
<style>
.cursor:hover {
  cursor: pointer;
}
</style>
